/*
 * DispenseEproDevicePopupController
 * */

/* eslint-disable no-underscore-dangle */
class DispenseEproDevicePopupController {
	constructor($timeout, iSpiroService, loadingIndicatorService,
		signatureService, appI18n, appConfig, $stateParams, $q,
		ertBasePopupService, notificationService, userService, eproService, appSession) {
		'ngInject';
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.iSpiroService = iSpiroService;
		this.loadingIndicatorService = loadingIndicatorService;
		this.signatureService = signatureService;
		this.ertBasePopupService = ertBasePopupService;
		this.notificationService = notificationService;
		this.userService = userService;
		this.eproService = eproService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.$q = $q;
		this.appSession = appSession;
		this.onlineHelpId = 'MSP3.ClinicalData.ISpiro.DispenseDevice';

		this.isLoading = false;
		this.$API = null;
		this.iSpiroForm = null;
		this.state = null;
		this.hasDOB = false;
		this.dobIsInFutureMsg = null;
		this.isFormValid = false;
		this.formData = null;
		this.phaseData = null;
		this.subjectDemographics = null;
		this.additionalAttributes = null;
		this.studyContext = null;
		this.siteId = null;
		this.subjectId = null;
		this.cancelBtn = null;
		this.isEdit = false;
		this.heading = 'Dispense Device';
		this.editDeviceValuesHeadingId = 'clinicaldata.subject.epro.editDeviceValuesPopupHeading';
		this.dispensePopupHeadingId = 'clinicaldata.subject.epro.dispensePopupHeading';
		this.displaySiteNames = [];
		this.displaySubjectKeys = [];
		this.deviceActionWidgetEl = null;
		this.languageKey = 'V2.GLOB.LANGUAGE';
		this.languageKeyHomeBp = 'CONDEV_HOMEBP_LANGUAGE';
		this.cuffSizeKey = 'IT_72';
		this.armKey = 'IT_71';
		this.source = null;
		this.externalSiteId = null;
		this.isHomeBpStudy = false;
		this.homeBpDemography = null;
		this.homeBpStudyConfigResponse = null;
		this.showQrCodeStateHomebp = false;
		this.readyToFetchQrCode = false;
		this.popupSize = 'small';
		this.protocolSetupLabels = [];


		this.errors = {
			genericError: false
		};

		// ACTION BUTTONS
		this.submitBtn = {
			action: () => {
				if(this.source !== 'RESP Biosensor')
				{
				if (!this.isFormValid) {
					this.validateForm();
					return;
				}
				}				
				this.dispenseDevice(this.source);
				this.clearActions();
			},
			cssClass: '-es-primary',
			displayName: 'app.buttons.submit',
			isDisabled: false,
			type: 'submit'
		};
		this.cancelBtn = {
			action: () => {
				this.cancelAction();
			},
			displayName: 'app.buttons.cancel',
			isDisabled: false
		};

		this.isEditBlocked = false;
	}

	$onInit() {

		this.configure();
		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					this.state = state;
				}
			}
		}
	}

	validateForm() {
		this.deviceActionWidgetEl[0].validateForm = true;
	}

	clearActions() {
		this.actions = [];
	}
	showQrCode() {
		const isForSampleSite = this.appSession.getStudyModeId() === this.appConfig.studyMode.sample;
		const qrCodePayload = {
			context: {
			  subjectContext: [
				{
				  studyId: this.studyContext.studyId,
				  siteId: this.studyContext.siteId,
				  subjectId: this.studyContext.subjectId,
				  externalSiteId: this.studyContext.externalSiteId,
				  externalSubjectId: this.studyContext.externalSubjectId
				}
			  ],
			  participantId: '',
			  appId: null,
			  externalAppId: '',
			  siteContext: null
			},
			type: 'appProvisioningRequest',
			data: {
			  isForSampleSite
			}
		  };
		  this.eproService.generateQrCode(qrCodePayload).then((response) => {
			this.deviceActionWidgetEl[0].qrCode = response.data.data.qrCodeContents;
			this.deviceActionWidgetEl[0].QRCodeValue = true;
			this.deviceActionWidgetEl[0].thresholds = [];
			this.loadingIndicatorService.hide();
		  }).catch(() => {
			this.loadingIndicatorService.hide();
		  });
	}


	showSuccessMessage() {
		this.popupSize = 'small';
		const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
		placeholderEl.empty().append('<h4>Subject data is updated.</h4>');
		this.loadingIndicatorService.hide();
	}

	dispenseDevice(source) {
		
		if (!this.formData) {
			this.$API.close();
			return;
		}
        if(source === 'RESP Biosensor')
		{
			this.loadingIndicatorService.show();
			this.eproService.generateStradosCoughQrCode(this.externalSiteId, this.subjectId).then((response) => {
				this.deviceActionWidgetEl[0].qrCode = response.data.data.qrCodeContents;
				this.deviceActionWidgetEl[0].QRCodeValue = true;
				this.deviceActionWidgetEl[0].qrCodePin = response.data.data.dispenseCode;
				this.loadingIndicatorService.hide();
			  }).catch(() => {
				this.loadingIndicatorService.hide();
			  });
		}
		else
		{
		const payload = this.formData?.thresholdValues ?? [];
		payload.push({
			key: this.isHomeBpStudy ? this.languageKeyHomeBp : this.languageKey,
			value: this.formData.selectedLanguage,
		});
		if (this.isHomeBpStudy){
			this.updateOrAddDemographic(this.armKey, this.formData.selectedArm, 'Arm');
			this.updateOrAddDemographic(this.cuffSizeKey, this.formData.selectedCuffSize, 'Cuff Size');
		}
		this.loadingIndicatorService.show();
        if (this.isHomeBpStudy){
			// to begin next part of HomeBPDispense work from here
			
				this.eproService.updateHomeBpSubject(this.studyContext.siteId, this.subjectId, {
					demographics: this.subjectDemographics,
					additionalAttr: payload
				})
			.then(() => {
                this.loadingIndicatorService.show();
                this.showScheduleWindow();
                this.showQrCodeStateHomebp = true;  
            }).catch(() => {
                this.loadingIndicatorService.hide();
            });
		}
		else {
		this.eproService.dispenseDevice(this.siteId, this.subjectId, {
			demographics: this.subjectDemographics,
			additionalAttr: payload
		}).then(() => {
			if (this.isEdit) {
				this.showSuccessMessage();
			} else {
				this.showQrCode();
			}
		}).catch(() => {
			this.loadingIndicatorService.hide();
		});
		}
	}
	}

	showScheduleWindow()
    {
        return new Promise((resolve, reject) => {
            this.loadingIndicatorService.show();
            this.$q.all([
                this.eproService.getHomeBpSubject(this.studyContext.siteId, this.subjectId),
                this.eproService.getHomeBpStudyConfiguration()
            ]).then((responses) => {
                const subjectResponse = responses[0];
                const configResponse = responses[1];
                const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
                this.deviceActionWidgetEl = angular.element('<device-action-dispense  />');
                this.deviceActionWidgetEl[0].HomeBpScheduleValue = true;
                this.deviceActionWidgetEl[0].homeBpSubject = subjectResponse.data;
                this.deviceActionWidgetEl[0].homeBpStudyConfig = configResponse.data;
				this.deviceActionWidgetEl[0].homeBpScheduleAction = this.isEdit ? 'update' : 'create';
                this.popupSize = 'large';
                placeholderEl.empty().append(this.deviceActionWidgetEl);
                
                // Set up listener AFTER element is appended to DOM
                this.$timeout(() => {
                    this.deviceActionWidgetEl[0].addEventListener('phaseDataChange', (event) => {
                        const phaseData = event.detail;
                        this.phaseData = phaseData;
                        
                        // Check if phaseData has items
                        if (this.phaseData && this.phaseData.length > 0) {
                            // Call schedule first
                            this.scheduleHomeBpSubject().then(() => {
                                // On success, generate QR code or show success message
                                if (this.isEdit) {
                                    this.showSuccessMessage();
                                } else {
                                    this.showQrCodeHomeBp().then((qrResponse) => {
                                    }).catch((error) => {
                                        this.notificationService.error('Error generating QR code');
                                    });
                                }
                            }).catch((error) => {
                                this.notificationService.error('Error scheduling phases');
                            });
                        }
                    });
                    this.loadingIndicatorService.hide();
                    resolve(); // Resolve only after listener is set up
                }, 100);
            }).catch((error) => {
                this.loadingIndicatorService.hide();
                reject(error);
            });
			
        });
    }

	showQrCodeHomeBp()
    {
        return new Promise((resolve, reject) => {
            const qrCodePayload = {
                context: {
                    subjectContext: [
                        {
                            studyId: this.studyContext.studyId,
                            siteId: this.studyContext.siteId,
                            subjectId: this.studyContext.subjectId,
                            externalSiteId: this.studyContext.externalSiteId,
                            externalSubjectId: this.studyContext.externalSubjectId
                        }
                    ],
                    participantId: '',
                    externalAppId: ''
                },
                type: 'AppProvisioningRequest',
                data: {
                    isForSampleSite: true
                }
            };

            this.loadingIndicatorService.show();
            this.eproService.generateHomeBpQrCode(qrCodePayload).then((response) => {
                this.deviceActionWidgetEl[0].qrCode = response.data.data.qrCodeContents;
                this.deviceActionWidgetEl[0].QRCodeValue = true;
                this.deviceActionWidgetEl[0].provisioningStatus = response.data.data.provisioningStatus;
				this.popupSize = 'small';
                const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
                placeholderEl.empty();
                placeholderEl.append('<div style="text-align: center;"><h4>Result QR Code</h4></div>');
                placeholderEl.append(this.deviceActionWidgetEl);
                
                this.loadingIndicatorService.hide();
                resolve(response.data);
            }).catch((error) => {
                this.loadingIndicatorService.hide();
                reject(error);
            });
        });
    }

	scheduleHomeBpSubject()
    {
        return new Promise((resolve, reject) => {
            const schedulePayload = {
                context: {
                    studyId: this.studyContext.studyId,
                    siteId: this.studyContext.siteId,
                    subjectId: this.studyContext.subjectId,
                    studyModeId: 0
                },
                data: this.phaseData.map(phase => ({
                    phase: phase.phase,
                    startDate: phase.startDate
                }))
            };

            this.loadingIndicatorService.show();
            this.eproService.scheduleHomeBpSubject(schedulePayload).then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject(new Error('Schedule failed with status: ' + response.status));
                }
                this.loadingIndicatorService.hide();
            }).catch((error) => {
                this.notificationService.error('Error scheduling phases');
                this.loadingIndicatorService.hide();
                reject(error);
            });
        });
    }

	configure() {
		this.popupHeading = 'clinicaldata.subject.i-spiro.close-dispense.dispenseTitle';
	}

	generateFinalObject(variablesWithThreshold, additionalAttributes) {
		const finalObject  = variablesWithThreshold.map(variable => {
			const key = variable?.threshold?.technicalName;
			const additionalAttribute = additionalAttributes.find(attr => attr.key === key);
			
			let value = null;
			if (variable?.threshold?.staticValue !== null && variable?.threshold?.staticValue !== undefined) {
				value = variable.threshold.staticValue;
			} else if (additionalAttribute?.value !== null && additionalAttribute?.value !== undefined) {
				value = additionalAttribute.value;
			}
			
			return {
				key,
				value,
				label: variable.threshold.displayName,
				requireThreshold: "true",
				displayDecimals: variable.displayDecimals ?? 0,
				name: variable.name,
				minValue: variable.threshold.rangeFrom,
				maxValue: variable.threshold.rangeTo,
				isEditable: variable.threshold.isEditable === "true"
			};
		});
	
		return finalObject;
	}

	setApi() {
		const $API = {
			open: (isRemoteAction, countryId, siteId, subjectId, displaySiteName, subjectKey, isEdit, source, isHomeBpStudy) => {
				
				this.loadingIndicatorService.show();
				this.popupSize = 'small';
				this.isEdit = isEdit;
				this.heading = isEdit
					? this.editDeviceValuesHeadingId
					: this.dispensePopupHeadingId;
				this.siteId = siteId;
				this.subjectId = subjectId;
				this.source = source;
				this.isHomeBpStudy = isHomeBpStudy;
				if(this.source === 'RESP Biosensor')
				{
					const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();
					const additionalAttributesPromise = this.eproService.getAdditionalAttributes(siteId, subjectId);
					this.$q.all([protocolSetupLabelsPromise, additionalAttributesPromise])
						.then((responses) => {
						const rawLabels = responses[0].data;
						const additionalAttributesResponse = responses[1];
						const protocolSetupLabels = [
							rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
							rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
						].filter(Boolean);
						this.protocolSetupLabels = protocolSetupLabels;


							this.studyContext = additionalAttributesResponse.data;
							this.externalSiteId = additionalAttributesResponse.data.siteId;
							this.additionalAttributes = additionalAttributesResponse.data.additionalAttr;
							this.subjectDemographics = additionalAttributesResponse.data.demographics.map(demo => {
								if (demo.value === null) {
									demo.value = '';
								}
								return demo;
							});

							this.actions = [this.submitBtn, this.cancelBtn];
							this.open = true;
							this.$timeout(() => {
								const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
								this.deviceActionWidgetEl = angular.element('<device-action-dispense  />');
								this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
									this.formData = event.detail;
								});
								this.deviceActionWidgetEl[0].siteIds = [displaySiteName];
								this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
								this.deviceActionWidgetEl[0].source = source;
								this.deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
								this.displaySiteNames = [displaySiteName];
								this.displaySubjectKeys = [subjectKey];
								this.popupSize = 'small';
								placeholderEl.empty().append(this.deviceActionWidgetEl);
								this.loadingIndicatorService.hide();
							}, 200);
						})
						.catch(() => {
							this.loadingIndicatorService.hide();
							this.notificationService.error('Error loading data');
						});
				}
				else{
				const studyConfigPromise = this.eproService.getStudyConfiguration();
				const additionalAttributesPromise = this.eproService.getAdditionalAttributes(siteId, subjectId);
				const homeBpAdditionalDataPromise = this.isHomeBpStudy ? this.eproService.getHomeBpAdditionalData() : Promise.resolve(null);
				const homeBpStudyConfigPromise = this.isHomeBpStudy ? this.eproService.getHomeBpStudyConfiguration() : Promise.resolve(null);
				const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();
				this.$q.all([studyConfigPromise, additionalAttributesPromise, homeBpAdditionalDataPromise, homeBpStudyConfigPromise, protocolSetupLabelsPromise])
				.then((responses) => {
					const studyConfigResponse = responses[0];
					const additionalAttributesResponse = responses[1];
					const homeBpAdditionalDataResponse = responses[2];
					const homeBpStudyConfigResponse = responses[3];
					const rawLabels = responses[4].data;
					const protocolSetupLabelsResponse = [
						rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
						rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
					].filter(Boolean);
					this.protocolSetupLabels = protocolSetupLabelsResponse;
					this.homeBpStudyConfigResponse = homeBpStudyConfigResponse;
					
					const patientAppProduct = studyConfigResponse.data.products
						.find(product => product.name === 'PATIENT_APP');
					const homeBpProduct = studyConfigResponse.data.products
						.find(product => product.name === 'CONDEV_HOMEBP');
					let variables = [];
					const phaseSessions = studyConfigResponse && studyConfigResponse.data && studyConfigResponse.data.calculations && Array.isArray(studyConfigResponse.data.calculations.phaseSessions)
						? studyConfigResponse.data.calculations.phaseSessions
						: [];
					if (phaseSessions.length > 0) {
						phaseSessions.forEach(phaseSession => {
							if (phaseSession && phaseSession.calculations && Array.isArray(phaseSession.calculations.variable)) {
								const varsWithThreshold = phaseSession.calculations.variable.filter(v => v && v.threshold !== null && v.threshold !== undefined && v.threshold.isDisplay == "true");
								if (varsWithThreshold && varsWithThreshold.length > 0) {
									variables = variables.concat(varsWithThreshold);
								}
							}
						});
					}

					const unbound = studyConfigResponse && studyConfigResponse.data && studyConfigResponse.data.calculations && Array.isArray(studyConfigResponse.data.calculations.unbound)
						? studyConfigResponse.data.calculations.unbound
						: [];
					
					if (unbound.length > 0) {
						unbound.forEach(unboundItem => {
							if (unboundItem && unboundItem.calculations && Array.isArray(unboundItem.calculations.variable)) {
								const unboundVarsWithThreshold = unboundItem.calculations.variable.filter(v => v && v.threshold !== null && v.threshold !== undefined && v.threshold.isDisplay == "true");
								if (unboundVarsWithThreshold && unboundVarsWithThreshold.length > 0) {
									variables = variables.concat(unboundVarsWithThreshold);
								}
							}
						});
					}

					const variablesWithThreshold = variables.filter(v => v.threshold !== null && v.threshold.isDisplay == "true");
					this.studyContext = additionalAttributesResponse.data;
					this.additionalAttributes = additionalAttributesResponse.data.additionalAttr;
					this.subjectDemographics = additionalAttributesResponse.data.demographics.map(demo => {
						if (demo.value === null) {
							demo.value = '';
						}
						return demo;
					});
					const finalObject = variablesWithThreshold && variablesWithThreshold.length > 0
						? this.generateFinalObject(variablesWithThreshold, this.additionalAttributes)
						: null;

					if (patientAppProduct || homeBpProduct) {
						const supportedLanguages = this.isHomeBpStudy ? homeBpProduct.supportedLanguages.map(lang => ({
							language: lang.language,
							displayName: lang?.displayName || lang.language
						})) : patientAppProduct.supportedLanguages.map(lang => ({
							language: lang.language,
							displayName: lang?.displayName || lang.language
						}));

						if (this.isHomeBpStudy && homeBpAdditionalDataResponse)
						{
							this.homeBpDemography = homeBpAdditionalDataResponse.data.demography
								.filter(d => d.type === 'BpArm' || d.type === 'BpCuffSize')
								.map(d => {
										const match = this.subjectDemographics?.find(sd => sd.key === d.key);
										const hasValue = match && match.value !== null && match.value !== undefined && match.value !== '';
										let formattedValue = null;
										
										if (hasValue) {
											// Only format if value contains hyphens (like ADULT-LARGE)
											if (match.value.includes('-')) {
												formattedValue = match.value.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('-');
											} else {
												// For values without hyphens, keep as-is
												formattedValue = match.value;
											}
										}
										
										return {
											...d,
											value: formattedValue
										};
									});
						}
						this.submitBtn.displayName = this.isHomeBpStudy ? 'Save and Next' : 'app.buttons.submit';
						this.actions = [this.submitBtn, this.cancelBtn];
						this.open = true;
						this.$timeout(() => {
							const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
							this.deviceActionWidgetEl = angular.element('<device-action-dispense  />');

							
							this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
								const formData = event.detail;
								this.formData = formData;
							  });
						
							this.deviceActionWidgetEl[0].addEventListener('formValidationChange', (event) => {
								const isFormValid = event.detail;
								this.isFormValid = isFormValid;
							  });

							this.deviceActionWidgetEl[0].languages = supportedLanguages;
							const languageAttribute = this.additionalAttributes.find(
								attr => attr.key ===  (this.isHomeBpStudy ? this.languageKeyHomeBp : this.languageKey)
							);
							this.deviceActionWidgetEl[0].selectedLanguage = languageAttribute
								? languageAttribute.value : null;
							if (finalObject) {
								this.deviceActionWidgetEl[0].thresholds = finalObject;
							}
							this.deviceActionWidgetEl[0].siteIds = [displaySiteName];
							this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
							this.deviceActionWidgetEl[0].homeBpAdditionalDemography = this.homeBpDemography;
							this.displaySiteNames = [displaySiteName];
							this.displaySubjectKeys = [subjectKey];
							this.deviceActionWidgetEl[0].source = source;
							this.deviceActionWidgetEl[0].vocabulary = protocolSetupLabelsResponse;
							this.popupSize = 'small';
							placeholderEl.empty().append(this.deviceActionWidgetEl);
							this.loadingIndicatorService.hide();
						}, 200);
					} else {
						this.loadingIndicatorService.hide();
						this.notificationService.error(
							'Study configuration is not set up correctly. ' +
							'Check the language settings for the patient app.'
						);
					}
					

                   
				})
				.catch((error) => {
					// Handle errors
					this.loadingIndicatorService.hide();
					this.notificationService.error('Error loading data');
				});
			}},
			close: () => {
				this.open = false;
				this.popupSize = 'small';
			}
		};
		return $API;
	}

	updateOrAddDemographic(key, value, label) {
		const existingIndex = this.subjectDemographics.findIndex(item => item.key === key);
		if (existingIndex > -1) {
			this.subjectDemographics[existingIndex].value = value;
		} else {
			this.subjectDemographics.push({ key, value, label });
		}
	}

	cancelAction() {
		this.$API.close();
	}

	getSignatureType() {
		return this.appConfig.sigType.noSignature;
	}

}
/* eslint-enable no-underscore-dangle */
export default DispenseEproDevicePopupController;
